import { useRuntimeVariables } from 'app-kit'
import { CustomFieldRolodexEntry } from 'features/assetDatabase/types/customField'
import { useGeckoAuth } from 'features/auth'
import { postFetcher } from 'features/rolodex'
import useSWR from 'swr'

export const useGetCustomSiteField = (siteID: string) => {
  const { authorizedAxios: axios } = useGeckoAuth()
  const { ROLODEX_URL } = useRuntimeVariables()
  const endpoint = `${ROLODEX_URL}/api/v2/entries/load`
  const customSiteFieldParams = {
    ids: [siteID],
    type: ['site'],
  }
  const bodyData = JSON.stringify(customSiteFieldParams)
  const { data, error, isLoading, isValidating } = useSWR<
    CustomFieldRolodexEntry[],
    Error,
    [string, string]
  >([endpoint, bodyData], ([endpoint, bodyData]) =>
    postFetcher(endpoint, bodyData, axios)
  )
  return {
    data,
    error,
    isLoading,
    isValidating,
  }
}
